import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireOttEvent, UmpireOttEventTranscodingStatus} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class OttEventService implements CrudService<UmpireOttEvent> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireOttEvent[]>> {
    return this.http
      .get('/ott/events', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttEvent>> {
    return this.http
      .get(`/ott/events/${fetchIdentifier}`, {
        params,
      })
      .pipe(deserialize());
  }

  delete(id: string, params?: JsonApiParams): Observable<void> {
    return this.http.delete(`/ott/events/${id}`, {params: objectToHttpParams(params)});
  }

  create(
    body: Partial<UmpireOttEvent>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttEvent>> {
    return this.http
      .post('/ott/events', serialize({stuff: body}), {params})
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireOttEvent>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttEvent>> {
    return this.http
      .patch(`/ott/events/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  isAllowedCountry(): Observable<boolean> {
    return this.http.get(`/ott/events/allowed_country`);
  }

  export(params?: JsonApiParams): Observable<Blob> {
    return this.http.get('/ott/events/export', {
      params: objectToHttpParams(params),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      responseType: 'blob',
    });
  }

  getTranscodingStatus(
    id: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttEventTranscodingStatus>> {
    return this.http.get(`/ott/events/${id}/status`, {params}).pipe(deserialize());
  }

  recreateEncoding(
    id: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttEvent>> {
    return this.http
      .post(
        `/ott/events/${id}/recreate_encoding`,
        {},
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
